import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const Cookies: React.FC = () => {
  const [analyticsConsent, setAnalyticsConsent] = useState(true);
  const [adsConsent, setAdsConsent] = useState(true);
  const [personalizationConsent, setPersonalization] = useState(true);
  const [year, setYear] = useState<number>(new Date().getFullYear());

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYear(currentYear);
  }, []);

  const navigate = useNavigate();

  // Check localStorage for previous consent
  useEffect(() => {
    const storedConsent = localStorage.getItem("cookieConsent");
    if (storedConsent) {
      const consentData = JSON.parse(storedConsent);
      setAnalyticsConsent(consentData.analytics || false);
      setAdsConsent(consentData.ads || false);
      setPersonalization(consentData.personalization || false);
    }
  }, []);

  const handleConsentSaveOmatValinnat = () => {
    if (personalizationConsent === true) {
      const consentData = {
        pakolliset: true,
        analytics: analyticsConsent,
        ads: adsConsent,
        personalization: personalizationConsent,
        dateSaved: new Date().toISOString(),
      };
      localStorage.setItem("cookieConsent", JSON.stringify(consentData));
    }
    navigate("/set-train-number");
  };

  const handleConsentSaveVainPakolliset = () => {
    navigate("/set-train-number");
  };

  const handleConsentSaveKaikki = () => {
    if (personalizationConsent === true) {
      const consentData = {
        pakolliset: true,
        analytics: true,
        ads: true,
        personalization: true,
        dateSaved: new Date().toISOString(),
      };
      localStorage.setItem("cookieConsent", JSON.stringify(consentData));
    }
    navigate("/set-train-number");
  };

  return (
    <div
      className="font-small mt-2"
      style={{
        maxWidth: "460px",
        overflow: "auto",
        marginRight: 20,
        color: "white",
        textAlign: "start",
        marginLeft: 68,
        marginBottom: 224,
      }}
    >
      <div>
        <h2 className="">Evästeet</h2>
        <p>
          Sovelluksemme käyttää evästeitä ja vastaavia seurantatekniikoita
          käyttäjäkokemuksen parantamiseksi, sivuston käytön analysoimiseksi
          sekä personoitujen mainosten näyttämiseksi Googlen mainosten ja
          analytiikan avulla.
        </p>

        <div>
          <p>
            <p style={{ display: "inline", marginRight: "4px" }}>
              Lisätietoja löydät
            </p>
            <Link
              to="/privacy-policy"
              className="nav-link"
              style={{ color: "darkgray", display: "inline" }}
            >
              Tietosuojakäytännöstämme
            </Link>
          </p>

          <div className="d-flex">
            <button
              style={{
                width: "fit-content",
                height: "40px",
                padding: 8,
                backgroundColor: "green",
                color: "lightgray",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "8px",
                borderRadius: "5px",
                border: "none",
                cursor: "pointer", // Change cursor to pointer
                boxShadow: "2px 2px 12px rgba(0, 0, 0, 0.6)",
                lineHeight: "1.1",
              }}
              onClick={() => handleConsentSaveKaikki()}
            >
              Hyväksy kaikki evästeet
            </button>
            <button
              style={{
                width: "fit-content",
                height: "40px",
                padding: 8,
                backgroundColor: "#1e5a72",
                color: "lightgray",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "8px",
                borderRadius: "5px",
                border: "none",
                cursor: "pointer", // Change cursor to pointer
                boxShadow: "2px 2px 12px rgba(0, 0, 0, 0.6)",
                lineHeight: "1.1",
              }}
              onClick={() => handleConsentSaveVainPakolliset()}
            >
              Salli vain pakolliset evästeet
            </button>
          </div>
          <h4 className="mt-5">Hallitse evästeasetuksia</h4>
        </div>

        <div className="mt-3">
          <div className="p-2 border mb-3" style={{ borderRadius: 12 }}>
            <h6>Pakolliset evästeet</h6>
            <p>
              Nämä evästeet ovat välttämättömiä, jotta sovelluksemme toimii
              oikein. Et voi kieltäytyä näistä evästeistä, koska ne
              mahdollistavat perustoiminnallisuudet.
            </p>
            <div
              className="form-check"
              style={{ marginLeft: 6, marginTop: "-6px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                checked={true}
                disabled
              />
              <label className="form-check-label">Pakolliset evästeet</label>
            </div>
            <p></p>
            <h6 className="mt-4">Personointievästeet</h6>
            <p>
              Nämä evästeet auttavat verkkosivustoa muistamaan tekemäsi valinnat
              ja tarjoamaan parannettuja, henkilökohtaisempia ominaisuuksia. Kun
              hyväksyt evästeet, tallennamme suostumuksesi selaimeesi, jotta
              emme kysy sitä uudelleen tulevilla vierailuillasi. Jos et hyväksy
              evästeiden käyttöä, suostumustasi ei tallenneta, ja kysymme
              suostumusta joka kerta, kun vierailet sivustollamme.
            </p>

            <div
              className="form-check"
              style={{ marginLeft: 6, marginTop: "-6px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                checked={personalizationConsent}
                onChange={(e) => setPersonalization(e.target.checked)}
              />
              <label className="form-check-label">Personointievästeet</label>
              <p style={{ color: "darkgray" }}>
                Hyväksymällä tämän, emme kysy sinulta evästeasetuksia uudestaan.{" "}
                <span
                  style={{ color: "white", textShadow: "1px 2px 2px white" }}
                >
                  Huom!
                </span>
              </p>
            </div>
          </div>
          <div className="p-2 border mb-3" style={{ borderRadius: 12 }}>
            <h6>Analytiikkaevästeet</h6>
            <p>
              Käytämme Google Analyticsia ymmärtääksemme, miten käyttäjät
              vuorovaikuttavat verkkosivustollamme. Google Analytics kerää
              tietoja, kuten IP-osoitteesi, laitetiedot, vierailusi kesto ja
              suorittamasi toimet sivustolla. Tätä tietoa käytetään
              verkkosivustomme käytettävyyden ja sisällön parantamiseen.
            </p>
            <div
              className="form-check"
              style={{ marginLeft: 6, marginTop: "-6px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                checked={analyticsConsent}
                onChange={(e) => setAnalyticsConsent(e.target.checked)}
              />
              <label className="form-check-label">Google Analytics</label>
            </div>
          </div>
          <div className="p-2 border mb-3" style={{ borderRadius: 12 }}>
            <h6>Mainosevästeet</h6>
            <p>
              Verkkosivustollamme käytetään mainoskumppaneiden, kuten Google Ads
              evästeitä. Nämä evästeet keräävät tietoja selauskäyttäytymisestäsi
              ja muista verkkosivustoista, joiden avulla he voivat näyttää
              sinulle kohdennettuja mainoksia eri sivustoilla. Lisäksi
              käyttämämme affiliate-linkit voivat asettaa evästeitä
              seuratakseen, että olet saapunut sivustolle meidän linkkiemme
              kautta, mikä mahdollistaa komission saamisen, jos teet ostoksen.
              Voit hallita näitä evästeitä ja muokata mainosasetuksiasi
              verkkosivustollamme tai kolmansien osapuolten tarjoamilla
              työkaluilla.
            </p>
            <div
              className="form-check"
              style={{ marginLeft: 6, marginTop: "-6px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                checked={adsConsent}
                onChange={(e) => setAdsConsent(e.target.checked)}
              />
              <label className="form-check-label">Mainosevästeet</label>
            </div>
          </div>

          <button
            style={{
              width: "fit-content",
              height: "40px",
              padding: 8,
              backgroundColor: "#1e5a72",
              color: "lightgray",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "8px",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer", // Change cursor to pointer
              boxShadow: "2px 2px 12px rgba(0, 0, 0, 0.6)",
            }}
            className="m-4"
            onClick={() => handleConsentSaveOmatValinnat()}
          >
            Tallenna asetukset
          </button>
        </div>
      </div>
      <nav
        style={{
          padding: "4px",
          backgroundColor: "#1e5a72",
          color: "lightgray",
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          fontSize: 11,
          zIndex: 2,
        }}
      >
        <div
          className="d-flex justify-content-center"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            maxWidth: "800px",
            margin: "0 auto",
            gap: "15px",
          }}
        >
          <Link to="/set-train-number" className="nav-link">
            minunjunani.fi
          </Link>
          <Link to="/privacy-policy" className="nav-link">
            Tietosuojakäytäntö
          </Link>
          <Link to="/cookies" className="nav-link">
            Evästeet
          </Link>
        </div>
        <div className="">&copy; {year} minunjunani.fi</div>
        <a
          href="https://www.digitraffic.fi/kayttoehdot/"
          target="_blank"
          style={{ color: "darkgray" }}
        >
          Liikennetietojen lähde Fintraffic / digitraffic.fi, lisenssi CC 4.0 BY
        </a>
      </nav>
    </div>
  );
};

export default Cookies;
